import { render, staticRenderFns } from "./SectionSolution.vue?vue&type=template&id=6836b100&scoped=true"
import script from "./SectionSolution.vue?vue&type=script&lang=ts"
export * from "./SectionSolution.vue?vue&type=script&lang=ts"
import style0 from "./SectionSolution.vue?vue&type=style&index=0&id=6836b100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6836b100",
  null
  
)

export default component.exports